export default __webpack_public_path__ + "static/media/darkAcademy.174a0c3b.svg";